{
  "common": {
    "show": "Mostra",
    "about": "Informazioni",
    "newPost": "Nuovo post",
    "active": "Attivo",
    "change": "Modifica",
    "remove": "Rimuovi",
    "cancel": "Annulla",
    "publish": "Pubblica",
    "save": "Salva",
    "draft": "Bozza",
    "scheduled": "Programmato",
    "published": "Pubblicato",
    "actions": "Azioni",
    "archive": "Archivia",
    "delete": "Elimina",
    "edit": "Modifica",
    "edited": "Modificato",
    "settings": "Impostazioni",
    "signUp": "Registrati",
    "by": "Da",
    "for": "per",
    "you": "Tu",
    "one": "uno",
    "option": "Opzione ",
    "registered": "Registrato",
    "to": "a",
    "allEvents": "Tutti gli eventi",
    "placeholder": "segnaposto",
    "percentOf": "% di",
    "private": "Privato",
    "updatedOn": "Aggiornato il",
    "blogPost": "Post del blog",
    "category": "Categoria",
    "author": "Autore",
    "status": "Stato",
    "errors": "Errori",
    "all": "Tutto",
    "archived": " Archiviato",
    "back": "Indietro",
    "restore": "Ripristina questa versione",
    "next": "Successivo",
    "previous": "Precedente",
    "continue": "Continua",
    "continueButton": "Continua",
    "paid": "Pagato",
    "free": "Gratis",
    "uploadImagesVideos": "Carica immagini / video",
    "upload": "Carica",
    "add": "Aggiungi",
    "on": "Attivo",
    "from": "da",
    "members": "membri",
    "visibility": "Visibilità",
    "public": "Pubblico",
    "description": "Descrizione",
    "managedBy": "Gestito da",
    "noManagers": "Nessun responsabile",
    "noDescription": "Nessuna descrizione",
    "more": "Più",
    "moreCaps": "Più",
    "less": "meno",
    "and": "e",
    "in": "in",
    "allSet": "Tutto è pronto!",
    "createdBy": "Creato da",
    "home": "Home",
    "selected": "Selezionato",
    "groupMembers": "Membri del gruppo",
    "everyone": "Tutti",
    "manager": "Responsabile",
    "leave": "Lascia",
    "membersList": "Elenco dei membri",
    "findChannelManagers": "Trova responsabili di canale",
    "searchGroupMembers": "Cerca membri del gruppo",
    "searchMembers": "Cerca membri",
    "searchMember": "Cerca membro",
    "enterDescription": "Inserisci descrizione",
    "apply": "Applica",
    "selectRole": "Seleziona ruolo",
    "people": "Persone",
    "viewProfile": "Visualizza profilo",
    "leaderboard": "Classifica",
    "events": "Eventi",
    "logOut": "Disconnettiti",
    "topLevelReached": "Primo livello raggiunto",
    "topLevelReachedExclaim": "Primo livello raggiunto!",
    "congratsTopLevel": "Congratulazioni! Hai raggiunto il primo livello!",
    "share": "Condividi",
    "copyLink": "Copia link",
    "reply": "Risposta",
    "download": "Scarica",
    "noPreviewAvailable": "Nessuna anteprima disponibile",
    "userNotFound": "Utente non trovato",
    "userNotFoundMessage": "Utente non trovato",
    "thisGroupIsPrivate": "Questo gruppo è privato",
    "unableToPreviewPdf": "Al momento non è possibile visualizzare l'anteprima del file PDF. Scaricalo per visualizzarlo.",
    "failedToDownloadPdf": "Impossibile scaricare il file PDF",
    "notifyAll": "Notifica tutti nel canale",
    "communities": "Comunità",
    "courses": "Corsi",
    "affiliates": "Affiliati",
    "chats": "Chat",
    "switchToDarkMode": "Passa alla modalità scura",
    "switchToLightMode": "Passa alla modalità chiara",
    "editProfile": "Modifica profilo",
    "account": "Account",
    "logout": "Disconnessione",
    "noResults": "Nessun risultato",
    "confirmPayment": "Conferma pagamento",
    "done": "Fatto",
    "manage": "GESTISCI",
    "copied": "Copiato",
    "submit": "Invia",
    "request": "Richiesta",
    "approve": "Approva",
    "decline": "Rifiuta",
    "comingSoon": "In arrivo",
    "detailsUpdatedSuccessfully": "Dettagli aggiornati con successo",
    "oopsUnableToSaveDetails": "Ops! Impossibile salvare i dettagli.",
    "verificationFailedPleaseTryAgain": "Verifica non riuscita! Riprova",
    "loading": "Caricamento",
    "title": "Titolo",
    "addLink": "Aggiungi link",
    "writeHere": "Scrivi qui",
    "copy": "Copia",
    "reset": "Reimposta",
    "register": "Registrati",
    "search": "Cerca",
    "confirm": "Conferma",
    "success": "Successo",
    "toReview": "Da Recensione",
    "invite": "Invita",
    "contributions": "Contributi",
    "communitiesSettings": "Impostazioni delle comunità",
    "create": "Crea",
    "name": "Nome",
    "linkCopied": "Link Copiato!",
    "move": "Sposta",
    "irreversible": "irreversibile",
    "close": "Chiudi",
    "greeting": "Ciao, {name}!",
    "managePayments": "Gestisci i pagamenti",
    "manageYourAccount": "Gestisci il tuo Account",
    "accountSettings": "Impostazioni Account",
    "proceed": "Procedi",
    "uploading": "Caricamento",
    "retry": "Riprova",
    "login": "Accedi",
    "follow": "Segui",
    "following": "Successivo",
    "followers": "Follower",
    "view": "VISUALIZZA",
    "selectAnOption": "Seleziona un'opzione",
    "channels": "Canali",
    "somethingWentWrong": "Si è verificato un errore. Riprova",
    "switchToNormalMode": "Passa alla modalità normale",
    "switchToReadingMode": "Passi alla modalità di lettura",
    "goToHomepage": "Vai alla homepage",
    "onlyGroupOwnersCanCreateCourses": "Solo i proprietari dei gruppi possono creare nuovi corsi",
    "createGroup": "Crea gruppo",
    "discover": "Scopri",
    "continuePayment": "Continua il pagamento",
    "invalidCredentials": "Hai inserito un'e-mail o una password non valida. Riprova.",
    "comingUpEvents": "Eventi in arrivo!",
    "integratePaymentGateway": "Integra gateway di pagamento",
    "connectPaymentGateway": "Collega un nuovo gateway di pagamento o gestisci quelli esistenti.",
    "isLive": "è live",
    "justNow": "Appena adesso",
    "likes": "Mi piace",
    "accessRequired": "Accedi*",
    "zeroProgress": "0",
    "noFollowersTitle": "Sembra che nessuno ti segua.",
    "noFollowersSubtext": "Aggiungi la tua connessione all'elenco da seguire",
    "noFollowingTitle": "Tu non stai ancora seguendo nessuno.",
    "noFollowingSubtext": "Inizia a seguire le persone per vedere i loro post",
    "followBack": "Segui anche tu",
    "logIn": "ACCEDI",
    "video": "Video",
    "audio": "Audio",
    "newVersionAvailable": "È disponibile una nuova versione dell'app. Aggiornala per utilizzare questa funzionalità!",
    "ariaLabels": {
      "backButton": "Pulsante Indietro",
      "openEventLocation": "Apri luogo dell'evento",
      "editEvent": "Modifica evento",
      "deleteEvent": "Elimina evento",
      "cancelRsvp": "Annulla RSVP",
      "publicGroupRadio": "Radio button Gruppo pubblico",
      "privateGroupRadio": "Radio button Gruppo privato",
      "accessibleFromSwitcherCheckbox": "Casella di controllo Accessibile dallo strumento di cambio",
      "allowMembersToInviteCheckbox": "Casella di controllo Consenti ai membri di invitare",
      "addMembers": "Aggiungi membri",
      "settings": "Impostazioni",
      "leaveChannel": "Lascia canale",
      "channelSettings": "Impostazioni canale",
      "selectRole": "Seleziona ruolo",
      "deleteChannel": "Elimina canale",
      "changeToPrivateChannel": "Cambia in canale privato",
      "allowMembersToPosts": "Consenti ai membri di pubblicare post",
      "restrictMembersFromPosts": "Impedisci ai membri di inviare post",
      "close": "Chiudi",
      "open": "Apri",
      "more": "Più",
      "upload": "Carica",
      "play": "Riproduci",
      "pause": "Sospendi",
      "mute": "Disattiva il microfono",
      "unmute": "Riattiva il microfono",
      "fullscreen": "Schermo intero",
      "exitFullscreen": "Esci dalla modalità a schermo intero",
      "download": "Scarica",
      "share": "Condividi",
      "like": "Mi piace",
      "comment": "Commenta",
      "reply": "Rispondi",
      "pin": "Pin",
      "unpin": "Rimuovi dall'alto",
      "report": "Report",
      "copyLink": "Copia link",
      "embedCode": "Codice di incorporamento",
      "previewImage": "Immagine di anteprima",
      "profileImage": "Immagine del profilo",
      "coverImage": "Immagine di copertina",
      "thumbnail": "Miniatura",
      "attachment": "Allegato",
      "removeAttachment": "Rimuovi allegato",
      "uploadFile": "Carica il file",
      "selectFile": "Seleziona file",
      "searchIcon": "Icona di ricerca",
      "menuIcon": "Icona del menu",
      "notification": "Notifica",
      "messages": "Messaggi",
      "profile": "Profilo",
      "logout": "Disconnessione",
      "send": "Invia",
      "cancel": "Annulla",
      "submit": "Invia",
      "next": "Successivo",
      "previous": "Precedente",
      "refresh": "Aggiorna",
      "filter": "Filtra",
      "sort": "Ordina",
      "view": "Visualizza",
      "expand": "Espandi",
      "collapse": "Comprimi",
      "downloadFile": "Scarica file",
      "closeModal": "Chiudi la finestra modale",
      "addMedia": "Aggiungi contenuti multimediali",
      "lightModeRadio": "Radio Button Modalità chiara",
      "darkModeRadio": "Radio button Modalità scura",
      "communityThemeRadio": "Radio button Tema della comunità",
      "userProfile": "Profilo Utente",
      "postActions": "Azioni di pubblicazione",
      "chatWindow": "Finestra chat",
      "chatActions": "Azioni chat",
      "minimizeChat": "Riduci a icona la chat",
      "closeChat": "Chiudi chat",
      "commentActions": "Azioni di commento",
      "replyToComment": "Rispondi al commento",
      "groupLogo": "Logo del gruppo",
      "pinGroupIcon": "Fissa icona del gruppo",
      "appSwitcher": "Strumento di cambio app",
      "communities": "Comunità",
      "courses": "Corsi",
      "search": "Cerca",
      "giphyLogo": "Logo Giphy",
      "backToConversations": "Torna a Conversazioni",
      "commentAttachments": "Allegati dei commenti",
      "tabSwitcher": "Strumento di cambio schede",
      "eventCover": "Copertura evento",
      "eventCoverPreview": "Anteprima Copertura evento",
      "selectPaidEvent": "Seleziona Evento a pagamento",
      "selectFreeEvent": "Seleziona Evento gratuito",
      "selectCurrency": "Seleziona la valuta",
      "logo": "Logo",
      "closeReviewMembershipAnswersModal": "Chiudi finestra modale Revisione delle risposte di iscrizione",
      "liveStream": "Streaming live",
      "openGroupMembers": "Membri del gruppo aperto",
      "communityBanner": "Banner della comunità",
      "home": "Home",
      "mentionItem": "Menziona elemento",
      "back": "Indietro",
      "viewGroup": "Visualizza gruppo",
      "invitationIcon": "Icona Invito",
      "openUserProfile": "Apri il profilo utente",
      "closeStream": "Chiudi il flusso",
      "groupAvatar": "Avatar della comunità",
      "bannerImage": "Immagine del banner",
      "avatarImage": "Immagine avatar",
      "userAvatar": "Avatar utente",
      "eventImage": "Immagine evento",
      "postImage": "Immagine del post",
      "channelIcon": "Icona del canale",
      "groupIcon": "Icona del gruppo",
      "communityIcon": "Icona della comunità",
      "memberAvatar": "Avatar del membro",
      "creatorAvatar": "Avatar del creatore",
      "authorAvatar": "Avatar dell'autore",
      "aboutFeaturedPost": "Informazioni sul post in primo piano",
      "accountSettings": "Impostazioni dell'account",
      "addChannel": "Aggiungi canale",
      "addCourse": "Aggiungi corso",
      "addEmoji": "Aggiungi emoji",
      "affiliates": "Affiliati",
      "announceEvents": "Annuncia eventi",
      "avatar": "Avatar",
      "badge": "Distintivo",
      "camera": "Fotocamera",
      "cardImage": "Immagine della carta",
      "categoryName": "Nome categoria",
      "channelList": "Elenco Canali",
      "channelSelect": "Selezione canale",
      "chatAttachment": "Allegato chat",
      "chats": "Chat",
      "closeCourseDetails": "Chiudi dettagli del corso",
      "closeLoginModal": "Chiudi la finestra modale Accedi",
      "closeMembershipQuestionsModal": "Chiudi la finestra modale delle domande di iscrizione",
      "closePaymentModal": "Chiudi la finestra modale di pagamento",
      "commentCard": "Scheda commento",
      "communityTheme": "Tema della comunità",
      "conversationItem": "Elemento di conversazione",
      "conversationSuggestion": "Suggerimento di conversazione",
      "createChannel": "Crea canale",
      "customThemeRadio": "Radio button Tema personalizzato",
      "deleteAnswerButton": "Pulsante Elimina risposta",
      "deleteFile": "Elimina file",
      "editLevelName": "Modifica il nome del livello",
      "editProfile": "Modifica profilo",
      "enterEmailAddress": "Inserisci l'indirizzo email",
      "featuredIcon": "Icona in evidenza",
      "giveAdministrativePrivileges": "Concedi privilegi amministrativi",
      "gokollabLogo": "Logo GoKollab",
      "icon": "Icona",
      "image": "Immagine",
      "likeContent": "Metti Mi piace ai Contenuti multimediali",
      "link": "Link",
      "marketplaceGroupSlug": "Slug del gruppo marketplace",
      "microphone": "Microfono",
      "nextAttachment": "Allegato successivo",
      "noEvents": "Nessun evento",
      "noCommunitiesIllustration": "Nessuna illustrazione di comunità",
      "noCoursesFound": "Nessun corso trovato",
      "noFollowers": "Nessun follower",
      "noFollowing": "Nessun follower",
      "noPostsFound": "Nessun post trovato",
      "notificationItem": "Elemento di notifica",
      "notificationsList": "Elenco notifiche",
      "openEmbeds": "Apri incorporamenti",
      "openEmbedsDrawer": "Apri il cassetto degli Incorpora",
      "openEventColor": "Apri colore evento",
      "openEventDetails": "Apri dettagli evento",
      "permissionNeeded": "Autorizzazione necessaria",
      "pointsAndLevels": "Punti e livelli",
      "previousAttachment": "Allegato precedente",
      "reactedUser": "Utente che ha reagito",
      "reward": "Ricompensa",
      "rewards": "Ricompense",
      "selectChannel": "Seleziona canale",
      "selectEventOption": "Seleziona opzione evento",
      "selectIcon": "Seleziona icona",
      "selectTimezone": "Seleziona fuso orario",
      "showChannelIcons": "Mostra icone dei canali",
      "sidebarActionButton": "Pulsante di azione della barra laterale",
      "speaker": "Altoparlante",
      "text": "Testo",
      "thisGroupIsPrivate": "Questo gruppo è privato",
      "toReview": "Da rivedere",
      "toggleFeaturedPost": "Toggle Condividi in primo piano",
      "toggleRewardsOptions": "Attiva/disattiva le opzioni di ricompensa",
      "viewReplies": "Visualizza risposte",
      "courseThumbnail": "miniatura-corso",
      "moreManagers": "più responsabili",
      "arrowIcon": "→",
      "okHandEmoji": "👌",
      "closeIcon": "✕",
      "changeToPublicChannel": "Cambia in canale pubblico",
      "showMandatoryInfoModal": "Casella di controllo Mostra la finestra modale obbligatoria del profilo"
    },
    "placeholders": {
      "groupName": "Nome del gruppo",
      "groupSlug": "Slug del gruppo",
      "url": "URL",
      "enterPrice": "Inserisci il prezzo",
      "enterName": "Inserisci nome",
      "enterEmail": "Inserisci email",
      "selectTimezone": "Seleziona fuso orario",
      "selectChannel": "Seleziona canali",
      "enterSkoolGroupUrl": "Inserisci l'URL del tuo gruppo Skool"
    },
    "email": "Email",
    "errorLoadingConversations": "Errore durante il caricamento delle conversazioni",
    "noConversations": "Nessuna conversazione"
  },
  "imageUpload": {
    "cropYourAvatar": "Ritaglia il tuo avatar",
    "dragToReposition": "Trascina per riposizionare",
    "ariaLabels": {
      "imageUploader": "Uploader di immagini",
      "avatar": "Avatar",
      "clearFile": "Cancella file",
      "removeAvatar": "Rimuovi l'avatar del profilo",
      "zoomButton": "Pulsante Zoom"
    }
  },
  "mediaUpload": {
    "uploadVideo": "Carica video",
    "addVideoUsingLink": "Aggiungi video tramite link",
    "uploadImage": "Carica immagine",
    "addVideo": "Aggiungi video"
  },
  "mandatedInfoModal": {
    "completeYourProfile": "Completa il tuo profilo",
    "profileIntentMessage1": "Le comunità sembrano strane senza volti e nomi.",
    "profileIntentMessage2": "I profili creano fiducia e alimentano le connessioni con gli altri",
    "complete": "COMPLETATO",
    "recommendedAspectRatio": "Carica un {types}. Consigliato Aspetto Percentuale 1:1",
    "addBio": "Aggiungi una biografia... (Opzionale)"
  },
  "validations": {
    "nameRequired": "Il nome è obbligatorio!",
    "invalidDescription": "Descrizione non valida!"
  },
  "payment": {
    "recurringWithTrial": "Ti verranno addebitati {currencySymbol}{price} per {interval} dopo il periodo di prova con la possibilità di annullare in qualsiasi momento.",
    "recurring": "{currencySymbol}{price} per {interval} con la possibilità di annullare in qualsiasi momento.",
    "oneTime": "{currencySymbol}{price} {paymentText}",
    "defaultOneTimeText": "prezzo una tantum per l'iscrizione.",
    "totalAmount": "Importo totale",
    "trialDays": "Prova di {days} giorni",
    "securePayments": "Pagamenti sicuri al 100%",
    "allowToChargeCard": "Fornendo i dati della tua carta, consenti a {locationName} di addebitare sulla carta i pagamenti futuri in conformità con i loro termini.",
    "paymentSuccessful": "Pagamento riuscito!"
  },
  "channel": {
    "notifications": {
      "managersEdited": "Responsabili modificati!",
      "managersAdded": "Responsabili aggiunti!",
      "managersAddedToChannel": "manager aggiunti a",
      "membersAdded": "Membri aggiunti correttamente!",
      "memberPostingEnabled": {
        "title": "Invio aggiornato con successo Membri",
        "content": "La pubblicazione di Membri è stata Abilitato"
      },
      "roleUpdated": "Ruolo aggiornato con successo!",
      "updatedRoleOf": "Ruolo aggiornato di {name}",
      "userRemoved": "Utente rimosso correttamente!",
      "removedUserFrom": "Rimuovi {name} da {channelName}",
      "errorOccurred": "Si è verificato un errore",
      "updated": {
        "title": "Impostazioni del canale aggiornate",
        "contentPrivate": "Il Canale {channelName} è ora privato.",
        "contentPublic": "Il canale {channelName} è ora pubblico",
        "content": ""
      },
      "deleted": {
        "title": "Canale eliminato",
        "content": ""
      },
      "membersAddedSuccess": {
        "title": "Membri aggiunti correttamente!",
        "content": "{count} membri aggiunti a {channelName}"
      },
      "managersAddedSuccess": {
        "title": "Responsabili aggiunti correttamente!",
        "content": "{count} manager aggiunti a {channelName}"
      },
      "memberPostingDisabled": {
        "title": "Invio aggiornato con successo Membri",
        "content": "Il post di Membri è stato Disabilitato"
      },
      "visibilityChangedToPublic": "Il canale {channelName} è ora pubblico",
      "visibilityChangedToPrivate": "Il canale {channelName} è ora privato",
      "created": {
        "title": "Nuovo canale creato",
        "content": ""
      },
      "error": {
        "createFailed": {
          "title": "Impossibile creare il canale",
          "content": "Riprova più tardi"
        },
        "updateFailed": {
          "title": "Impossibile aggiornare il canale",
          "content": "Riprova più tardi"
        },
        "managersEditedFailed": {
          "title": "Aggiornamento dei responsabili non riuscito!",
          "content": ""
        },
        "addFailed": {
          "title": "Aggiunta dei responsabili non riuscita!",
          "content": ""
        },
        "addMembersFailed": {
          "title": "Aggiunta dei membri non riuscita!",
          "content": ""
        }
      }
    },
    "createChannel": "Crea CANALE",
    "updateChannel": "AGGIORNA CANALE",
    "addMembers": "Aggiungi membri",
    "addManagers": "Aggiungi responsabili",
    "typeToAddMoreMembers": "Digita per aggiungere altri membri",
    "examplePlaceholder": "es. John o Jane",
    "makeChannelManager": "Nomina responsabile di canale",
    "removeFromChannelManager": "Rimuovi dal ruolo di responsabile di canale",
    "manager": "Responsabile",
    "channelManager": "Responsabile di canale",
    "noMembersFound": "Nessun membro trovato.",
    "noManagersFound": "Nessun responsabile trovato.",
    "removeChannelMember": "Rimuovi membro del canale",
    "removeConfirmationMessage": "Vuoi davvero rimuovere",
    "makeManagerConfirmationMessage": "Vuoi davvero nominare",
    "makeManagerConfirmationMessage2": "responsabile di canale in",
    "channelName": "Nome del canale",
    "channelIcon": "Icona del canale",
    "addChannel": "Aggiungi canale",
    "editChannel": "Modifica Canale",
    "announcementChannel": "Canale AVVISO",
    "noChannelsAvailable": "Nessun canale disponibile",
    "makeChannelPrivate": "Rendi canale privato",
    "makeChannelPrivateMessage": "Limita l'accesso dei membri a tutte le discussioni e interazioni del canale.",
    "readOnlyChannel": "Canale di sola Leggi",
    "readOnlyChannelMessage": "Membri può Visualizza IMPORTANTE informazioni e aggiornamenti, ma solo gli amministratori/proprietari del canale possono condividere qui.",
    "createPrivateChannel": "Rendi questo canale privato",
    "createPrivateChannelMessage": "Solo Membri invitati. I non Membri non vedranno questo Spazio",
    "allowMembersToPost": "Abilita Membri a condividere",
    "allowMembersToPostMessage": "Abilitando questa opzione Abilita Membri a creare post e feedback",
    "enableMemberPostingConfirmation": {
      "mainMessage": "L'abilitazione della pubblicazione di Membri abiliterà ogni Membri a creare e condividere post all'interno del canale.",
      "mainMessage2": "Assicurati che ogni Membri sia a conoscenza delle Autorizzazioni di pubblicazione del Nuovo.",
      "pointer1": "Questa Azione può essere ripristinata presso qualsiasi dato.",
      "pointer2": "ogni post Creato da Membri sarà visibile a Tutti in canale."
    },
    "privateChannelTooltip": "Non hai accesso a questo canale",
    "restrictMembersFromPosting": "Limita la pubblicazione di Membri Da",
    "restrictMembersFromPostingMessage": "Disabilita questa opzione impedirà a Membri Da Creato O di modificare i post e i feedback all'interno del canale.",
    "disableMemberPostingConfirmation": {
      "mainMessage": "La pubblicazione di Disabilita Membri limiterà ogni Membri Da Creato e la condivisione di post all'interno del canale.",
      "mainMessage2": "Assicurati che ogni Membri sia a conoscenza delle restrizioni di pubblicazione del Nuovo.",
      "pointer1": "Questa Azione può essere ripristinata presso qualsiasi dato.",
      "pointer2": "ogni post Creato da Membri Prima questa Modifica rimarrà visibile a Tutti in canale."
    },
    "deleteChannel": "Elimina canale",
    "deleteChannelMessage": "L'eliminazione del canale comporterà la perdita definitiva di tutti i dati associati.",
    "deleteChannelMessageWithCourse": "Eliminazione il canale perderai definitivamente tutti i dati Membri e tutti i Corsi collegati a questo canale diventerà Pubblico a meno che tu non li elimini prima.",
    "editChannelName": "Modifica il nome del canale",
    "editChannelDescription": "Modifica la descrizione del canale",
    "channelNamePlaceholder": "ad esempio, report di marketing",
    "editManagers": "Modifica responsabili",
    "channelManagers": "Responsabili di canale",
    "leaveChannel": "Lascia canale",
    "leaveChannelConfirmation": "Sei sicuro che tu voglia lasciare questo canale?",
    "changeToPrivateChannel": "Rendi canale privato",
    "changeToPrivateChannelMessage": "Rendendo il canale privato, l'utilizzo del canale per interazioni e discussioni sarà limitato ai soli membri.",
    "changeToPrivateChannelConfirmation": {
      "mainMessage": "Passando a questo canale su Privato LIMITE DI FASCE ORARIE accederà a Solo membri e manager.",
      "mainMessage2": "Ricorda di includere ogni Membri desiderato sul tuo canale Privato.",
      "pointer1": "Questa Azione è",
      "pointer2": "Il Nuovo Membri aggiunto al canale avrà Accesso a ogni PASSATO per le discussioni e le interazioni all'interno del canale."
    },
    "changeToPublicChannel": "Rendi canale pubblico",
    "changeToPublicChannelMessage": "Rendere il Canale Pubblico Abilita Tutti i Membri del Gruppo a Visualizza e unisciti in questo Canale.",
    "changeToPublicChannelConfirmation": {
      "mainMessage": "Impostando questo canale come pubblico, sarà accessibile a tutti i membri del gruppo.",
      "mainMessage2": "Tutti i membri del gruppo potranno visualizzare e unirsi a questo canale.",
      "pointer1": "Tutti i membri della comunità avranno accesso a questo canale automaticamente.",
      "pointer2": "I contenuti multimediali del canale privato passato diventeranno visibili a tutti i membri del gruppo."
    },
    "publicChannel": "Canale pubblico",
    "peopleWhoCanManage": "Persone che possono gestire",
    "addChannelHelperText": "Mostra di più comunità: aggiungi canali per discussioni diverse, Duet e connessione.",
    "privateChannel": "Canale privato",
    "removeFromChannel": "Rimuovi dal canale",
    "removeConfirmationMessage2": "da questo canale",
    "findChannelManagers": "Trova responsabili di canale",
    "removeChannelManager": "Rimuovi responsabile di canale",
    "irreversible": "Questa azione è irreversibile."
  },
  "chat": {
    "unblockUser": "Sblocca utente",
    "blockUser": "Blocca utente",
    "blockMessage1": "Non potrai più inviare messaggi a questo utente.",
    "blockMessage2": "Questo account non verrà bloccato nel gruppo. Potresti ancora riuscire a vedere i suoi post, commenti e reazioni.",
    "deleteChat": "Elimina chat",
    "deleteChatMessage": "Vuoi davvero eliminare questa conversazione?",
    "block": "Blocca",
    "conversation": "conversazione",
    "youPrefix": "Tu: ",
    "messageNotSent": "Questo messaggio non è stato inviato",
    "sending": "Invio",
    "youAndUserKnowEachOther": "Tu e {name} vi conoscete",
    "startConversationWithHi": "Inizia una conversazione con un \"Ciao\"",
    "accountSettings": "Impostazioni dell'account",
    "blockedUserMessage": "Hai bloccato { name }, non puoi inviare o ricevere messaggi. Sblocca l'utente per iniziare una conversazione. Per rivedere l'elenco degli utenti bloccati, visita:",
    "blockRecipientMessage": "{ name } ti ha bloccato. Non puoi inviare o ricevere messaggi.",
    "nothingFound": "Nessun risultato!",
    "pleaseCheckUsername": "Controlla il nome utente e riprova",
    "startChatting": "Inizia a chattare",
    "noChatYet": "Sembra che tu non abbia ancora chattato con nessuno.",
    "noChatYetMessage": "Cerca un contatto e fai il primo passo!",
    "noConversationsFound": "Nessuna conversazione trovata",
    "searchMembersAndStartChatting": "Cerca i membri e inizia a chattare",
    "cannotMessageDeletedUser": "Tu non puoi caricare messaggi a un utente Eliminato",
    "message": "Messaggio",
    "media": "Contenuti multimediali",
    "files": "File"
  },
  "comments": {
    "reportComment": "Segnala commento",
    "reportCommentMessage": "Vuoi davvero segnalare questo commento?",
    "deleteComment": "Elimina commento",
    "editComment": "Modifica commento",
    "loadMoreReplies": "Carica più risposte",
    "deleteCommentMessage": "Vuoi davvero eliminare questo commento?",
    "writeComment": "Scrivi un commento",
    "comment": "COMMENTO",
    "cancel": "ANNULLA",
    "save": "SALVA",
    "replyingTo": "In risposta a",
    "newComment": "Nuovo commento",
    "latest": "Più recente",
    "onlyAdminsCanComment": "Solo gli amministratori comunità possono commentare in questo canale.",
    "isCommentDisabledForPost": "Il feedback è disabilitato per questo post.",
    "isCommentDisabledErrorContent": "Il feedback su questo Condividere è stato Disabilitato dall'Editor o dall'Amministratore del Gruppo.",
    "isCommentDisabledErrorTitle": "Feedback disabilitati"
  },
  "embeds": {
    "uploadImage": "Carica immagine",
    "addYoutubeVimeoLoomLink": "Aggiungi un link Youtube, Vimeo o Loom",
    "uploadAttachment": "Carica file PDF, CSV o XLSX",
    "addAttachment": "Aggiungi allegato",
    "allowedTypes": "SVG, PNG, JPG o GIF (max. 800x400px)",
    "placeholder": "Aggiungi un link Youtube, Vimeo o Loom",
    "uploadVideo": "Carica/collega video",
    "uploadVideoPlaceholder": "Aggiungi un link Youtube, Vimeo o Loom",
    "uploadVideoAllowedTypes": "Carica un file video MP4",
    "addEmoji": "Aggiungi emoji",
    "emojiSuggestion": "Apre il selettore di emoji",
    "addGif": "Aggiungi GIF",
    "gifSuggestion": "Apre il selettore di GIF",
    "addImage": "Aggiungi immagine",
    "imageSuggestion": "Apre la tua galleria",
    "addVideo": "Aggiungi video",
    "videoSuggestion": "Apre la tua galleria",
    "selectFile": "Seleziona file",
    "attachmentSuggestion": "Apre il file manager",
    "takePhoto": "Scatta foto",
    "uploadPhotoVideo": "Carica foto/video",
    "limitExceeded": "Limite superato",
    "limitExceededMessage": "Non puoi allegare più di 4 file",
    "errorWhileUploadingFile": "Errore durante il caricamento del file! Riprova",
    "clickToUpload": "Fai clic per caricare",
    "orDragAndDrop": "oppure trascina e rilascia",
    "validUrl": "È necessario un URL valido",
    "enterSomeText": "Inserisci del testo",
    "addLink": "Aggiungi link",
    "text": "Testo",
    "addVideoLink": "O, includi un Link Video YouTube, Vimeo, Loom o Wistia .",
    "uploadVideoAndImages": "Carica video e immagini",
    "recommendedAspectRatio": "Consigliato Aspetto Percentuale {ratio}",
    "addHashtag": "Etichetta canali, occorrenze e Corsi",
    "hashtagSuggestion": "Suggerimento Hashtag"
  },
  "tabSwitcher": {
    "discussion": "Discussione",
    "learning": "Apprendimento",
    "members": "Membri",
    "people": "Persone",
    "leaderboard": "Classifica",
    "channels": "Canali",
    "groups": "Gruppi",
    "more": "Più",
    "home": "Home",
    "discover": "Scopri",
    "courses": "Corsi",
    "communities": "Comunità"
  },
  "groupInfo": {
    "pinGroup": "Gruppo di spille",
    "unpinGroup": "Sblocca il Gruppo",
    "maxPinnedGroupsLimit": "È possibile bloccare fino a 4 gruppi",
    "publicGroup": "Gruppo Pubblico",
    "privateGroup": "Gruppo Privato",
    "coverImage": "Copertura gruppo",
    "members": "Membri",
    "posts": "Post",
    "admin": "Amministratore",
    "settings": "IMPOSTAZIONI",
    "inviteMembers": "INVITA MEMBRI",
    "answerQuestions": "Rispondi alle domande",
    "toJoin": "per unirti a {name}",
    "changeRole": "Modifica ruolo",
    "removeFromGroup": "Rimuovi dal gruppo",
    "contributor": "Collaboratore",
    "membershipAnswers": "Risposte di iscrizione",
    "unbanMember": "Annulla esclusione del membro",
    "banFromGroup": "Escludi dal gruppo",
    "requestedOn": "Richiesta il",
    "invitedOn": "Invito il",
    "joinedOn": "Unione effettuata",
    "noMembersFound": "Nessun membro trovato.",
    "youAreAllCaughtUp": "Tu're tutti hanno raggiunto—no Membri qui Destra ora!",
    "banUserConfirmation": "Vuoi davvero escludere l'utente dal gruppo?",
    "deleteContentCheckbox": "Elimina ogni contenuto creato da questo utente",
    "active": "Attivo",
    "admins": "Amministratori",
    "contributors": "Collaboratori",
    "requested": "Richiesto",
    "banned": "Escluso",
    "invited": "Invitato",
    "paymentReceived": "Pagamento ricevuto",
    "paymentInitiated": "Pagamento avviato",
    "answeredQuestions": "Domande con risposta",
    "answeredQuestionsMessage": "ha risposto alla seguente domanda per unirsi",
    "darkMode": "Modalità scura",
    "darkModeMessage": "Modifica l'aspetto della comunità per ridurre l'abbagliamento e dare tregua agli occhi.",
    "accessGranted": "Accesso concesso: inizia la tua avventura di apprendimento.",
    "stepIntoAction": "Entra in azione! Collaboriamo e divertiamoci.",
    "viewMembersAndMemberDetails": "Visualizza i membri e i dettagli dei membri",
    "reviewContentReportsAndMore": "Rivedi segnalazioni di contenuti e altro",
    "toReview": "Da rivedere",
    "switchToOtherGroups": "Passa ad Altro Gruppo",
    "placeholders": {
      "yourAnswer": "La tua risposta"
    },
    "notifications": {
      "userBanned": "Utente escluso dal gruppo",
      "somethingWentWrong": "Qualcosa è andato storto. Riprova più tardi."
    },
    "membershipSettings": "Impostazioni di iscrizione",
    "paymentFailed": "Pagamento non riuscito!",
    "paymentFailedMessage": "Pagamento non riuscito, la tua richiesta di unirti al gruppo è stata rifiutata.",
    "gamification": {
      "addRewards": "Aggiungi ricompense",
      "title": "Titolo",
      "description": "Aggiungi descrizione",
      "textbox": "Casella di testo",
      "singleSelect": "Selezione singola",
      "multipleSelect": "Selezione multipla",
      "question": "Domanda",
      "validations": {
        "titleRequired": "Fornisci un titolo",
        "descriptionRequired": "Fornisci una descrizione",
        "somethingWentWrong": "Qualcosa è andato storto. Riprova più tardi.",
        "updatedRewards": "Ricompense aggiornate"
      },
      "settings": {
        "updatedRewards": "Ricompense aggiornate"
      }
    },
    "customCode": {
      "advanced": "Avanzato",
      "testPreview": "Anteprima del test",
      "enableConfirmationMessage": "Abilita solo dopo aver verificato l'anteprima di test",
      "testPreviewMessage": "Si aprirà una nuova scheda con l'anteprima di test della tua comunità. Puoi usarla per verificare se il tuo codice personalizzato funziona come previsto.",
      "liveMode": "Modalità Live",
      "customJS": "JS Personalizzato",
      "customCSS": "CSS Personalizzato",
      "trackingCode": "Codice di tracciamento",
      "headerCode": "Codice Intestazione",
      "footerCode": "Codice Piè di pagina"
    },
    "branding": {
      "brandYourGroup": "Puoi personalizzare il tuo gruppo secondo la tua scelta qui",
      "updateBranding": "Aggiorna il Branding",
      "clickToUploadFavicon": "Fai clic per caricare la favicon",
      "dragAndDropFavicon": "Trascina e rilascia un file {types} (rapporto d'aspetto 1:1)",
      "clickToUploadCover": "Fai clic per caricare la copertina",
      "dragAndDropCover": "Trascina e rilascia un {types} (rapporto d'aspetto 16:9)",
      "clickToUploadLogo": "Fai clic per caricare il logo del gruppo",
      "dragAndDropLogo": "Trascina e rilascia un {types} (rapporto d'aspetto 1:1)",
      "aspectRatioMustBe1To1": "Il rapporto d'aspetto dell'immagine deve essere 1:1",
      "aspectRatioMustBe16To9": "Il rapporto d'aspetto dell'immagine deve essere 16:9",
      "favicon": "Favicon",
      "coverImage": "Immagine di copertina",
      "logo": "Logo",
      "invalidFileFormat": "Ops! Formato/tipo di file non valido.",
      "pleaseUploadImageType": "Tipi di file supportati: {types}"
    },
    "groupAppearance": {
      "description": "Tu puoi configurare il tuo Gruppo Aspetto per la tua scelta qui",
      "slug": "Aggiorna il tuo Gruppo Aspetto qui",
      "colorMode": "Modalità Colore",
      "previewTheLook": "Anteprima come sarà il tuo Gruppo Aspetto in modalità Chiaro e Scuro",
      "light": "Chiaro",
      "dark": "Scuro",
      "communityTheme": "Tema della comunità",
      "customTheme": "Tema Personalizzato",
      "windowGradient": "Gradiente Finestra",
      "applyGradientColorsToYourSidebarAndTopbar": "Applica i colori sfumati alla barra laterale e alla barra superiore",
      "labels": {
        "sidebarBackground": "Sfondo della barra laterale",
        "primary": "PRIMARIO",
        "secondary": "Secondario",
        "tertiary": "Terziario",
        "surface": "Superficie",
        "fontPrimary": "Carattere PRIMARIO",
        "fontSecondary": "Carattere secondario",
        "fill": "Colore Riempi",
        "border": "Bordo",
        "error": "Errore",
        "background": "Sfondo",
        "option": "Opzione"
      },
      "customThemes": {
        "default": "Predefinito",
        "zestyCitrus": "Agrume piccante",
        "royalVelvet": "Velluto reale",
        "sunnyDelight": "Delizia del sole",
        "lushMeadow": "Prato lussureggiante",
        "azureDreams": "Sogni azzurri",
        "bubblegumBliss": "Beatitudine di gomma da masticare",
        "ivoryWhisper": "Ivory Whisper",
        "midnightDeep": "Nel profondo della mezzanotte"
      },
      "unsavedChanges": "Dinamico non salvato",
      "unsavedChangesMessage": "Tu hai Tema Dinamico non salvato, sei sicuro che vuoi Annullare il Dinamico?"
    },
    "promotionalLinks": {
      "promotionalLinks": "Link promozionali",
      "createPromotionalLinkDescription": "Crea link promozionali per il tuo gruppo",
      "addPromotionalLink": "Aggiungi link",
      "deleteLink": "Elimina link",
      "deleteLinkConfirmation": "Vuoi davvero eliminare questo link?",
      "labels": {
        "description": "Descrizione",
        "url": "URL",
        "private": "Privato",
        "privateLinksDescription": "I link privati sono visibili solo ai membri del gruppo"
      },
      "placeholders": {
        "enterLinkDescription": "Inserisci descrizione del link",
        "enterLinkURL": "Inserisci URL del link"
      },
      "addPromotionalLinkDescription": "Crea Link promozionale per il tuo Gruppo",
      "ariaLabels": {
        "editLink": "Modifica link",
        "deleteLink": "Elimina link"
      }
    },
    "membershipQuestions": {
      "addQuestion": "Aggiungi domanda",
      "editQuestion": "Modifica domanda",
      "editLevelName": "Modifica il nome del livello",
      "addOption": "Aggiungi opzione",
      "level": "Livello",
      "name": "Nome",
      "addMembersQuestionsDescription": "Aggiungi domande ai membri da porre quando richiedono l'accesso al tuo gruppo",
      "enableMembershipQuestions": "Abilita domande di iscrizione",
      "membershipQuestions": "Domande di iscrizione",
      "deleteQuestion": "Elimina domanda",
      "deleteQuestionConfirmation": "Vuoi davvero eliminare questa domanda?",
      "labels": {
        "textBox": "Casella di testo",
        "singleSelect": "Selezione singola",
        "multipleSelect": "Selezione multipla",
        "enableMembershipQuestions": "Aggiungi almeno una Domanda alle domande dell'Abilità Iscrizione"
      },
      "validations": {
        "questionRequired": "Inserisci una domanda",
        "answerOptionsRequired": "Sono richieste almeno due opzioni e devono essere univoche",
        "somethingWentWrong": "Qualcosa è andato storto. Riprova più tardi.",
        "updatedQuestions": "Domande di iscrizione al gruppo aggiornate",
        "levelNameRequired": "Inserisci un nome del livello",
        "updatedLevelName": "Nome del livello aggiornato"
      },
      "placeholders": {
        "enterLevelName": "Nome del livello",
        "selectOne": "Seleziona uno",
        "keepItShort": "non dilungarti...",
        "exampleOffer": "ad es 10% Disabilitato Attivo primo acquisto"
      },
      "privacyNotice": "Comprendo che le mie risposte saranno Archivia e visibili agli amministratori del Gruppo.",
      "ariaLabels": {
        "editQuestion": "Modifica domanda",
        "deleteQuestion": "Elimina domanda"
      }
    },
    "gamificationAndRewards": {
      "title": "Personalizza livelli e ricompense",
      "description": "Personalizza i nomi dei livelli e aggiungi ricompense per un migliore coinvolgimento dei membri",
      "gamification": "Gamification",
      "rewards": "Ricompense",
      "addRewards": "Aggiungi ricompensa",
      "ariaLabels": {
        "toggleGamification": "Attiva/Disattiva le opzioni di Gamification"
      }
    },
    "invitations": {
      "invitationSentSuccessfully": "Invito inviato con successo",
      "invitationSentSuccessfullyDescription": "Invito inviato a {email}",
      "shareGroupLink": "Condividi link del tuo gruppo",
      "inviteMember": "Invita membro",
      "inviteMemberDescription": "Costruisci la tua comunità invitando un nuovo membro",
      "inviteViaEmail": "Invita tramite email",
      "invitedMembersWillBeAutoApproved": "I membri invitati saranno approvati automaticamente per unirsi al gruppo",
      "sendInvite": "INVIA INVITO",
      "permissionDenied": "Non hai l'autorizzazione per invitare Membri. Si prega di contattare il proprio amministratore.",
      "labels": {
        "giveAdministrativePrivileges": "Concedi privilegi amministrativi",
        "giveAdministrativePrivilegesDescription": "Abilita questo membro a eseguire tutte le azioni amministrative",
        "name": "Nome",
        "email": "Email",
        "nameLabel": "Nome",
        "emailLabel": "Email"
      },
      "placeholders": {
        "enterName": "Inserisci nome",
        "enterEmail": "Inserisci email"
      }
    },
    "groupDetails": {
      "updateGroupDetails": "Aggiorna dettagli del gruppo",
      "updateGroupDetailsDescription": "Aggiorna qui i dettagli del tuo gruppo",
      "slugNotAvailable": "Slug del gruppo non disponibile",
      "description": "Descrivi in dettaglio la natura delle discussioni che si svolgeranno all'interno del gruppo",
      "publicDescription": "Chiunque può vedere i post del gruppo e gli altri membri del gruppo",
      "privateDescription": "Solo i membri possono vedere i post del gruppo e gli altri membri del gruppo",
      "accessibleFromSwitcher": "Accessibile dallo strumento di cambio",
      "accessibleFromSwitcherDescription": "Il tuo gruppo sarà visibile a chi non appartiene al gruppo nello strumento di cambio",
      "allowMembersToInvite": "Abilita Membri a invitare Nuovi Membri",
      "allowMembersToInviteDescription": "Nascondi il pulsante di invito per Membri Quando diventato Disabilitato. Membri può invitare Altro solo se questo è Abilitato.",
      "showMandatoryInfoModal": "Mostra la finestra modale obbligatoria del profilo",
      "showMandatoryInfoModalDescription": "Se l'opzione è abilitata, ai membri verrà chiesto di completare le informazioni del proprio profilo quando si uniscono al gruppo.",
      "slug": "Slug del gruppo",
      "discovery": {
        "title": "Scoperta",
        "description": "Fatti scoprire da milioni di utenti attivi. Il gruppo sarà visibile nella pagina di scoperta una volta che avrai più di 10 membri.",
        "discoverChannels": "Scopri i canali",
        "joinGroupToExploreAllChannels": "unisci il Gruppo a esplorare ogni canale",
        "categoryIsUsedOnlyOnGokollab": "La categoria è utilizzata solo su Gokollab",
        "categoryAutomaticallySuggested": "La categoria viene suggerita automaticamente utilizzando l'AI in base al titolo e alla descrizione del tuo gruppo. Per un suggerimento più accurato, assicurati che i dettagli del tuo gruppo riflettano chiaramente il suo scopo e i suoi argomenti.",
        "categoryRefreshLimited": "L'aggiornamento della categoria è limitato a una volta ogni 24 ore"
      },
      "placeholders": {
        "description": "Inserisci una breve descrizione"
      },
      "validations": {
        "nameRequired": "Inserisci un nome di gruppo valido!",
        "slugRequired": "Inserisci uno slug di gruppo valido!",
        "specialCharacterNotSupported": "Carattere speciale non supportato",
        "descriptionRequired": "La descrizione del gruppo è obbligatoria!",
        "emailRequired": "Inserisci un'email valida!",
        "fullNameRequired": "Inserisci un nome valido!"
      },
      "labels": {
        "groupName": "Nome Gruppo"
      }
    },
    "subscriptions": {
      "manageSubscriptions": "Gestisci il tuo Abbonamento",
      "viewAndManageGroupSubscriptions": "Visualizza e Gestisci Gruppo Abbonamento",
      "paymentIntegrationMissingMessage": "Integra i pagamenti in Luogo ad Abilita Pagato Gruppo",
      "price": "Prezzo",
      "currency": "Valuta",
      "priceDisplay": "{symbol}{price}{suffix}",
      "priceInterval": "/{interval}",
      "oneTime": " Un dato",
      "priceDeletedAlert": "Il prodotto Pagamento è Da Sincronizzazione, fai clic qui per risincronizzazione",
      "intervals": {
        "month": "Mese",
        "year": "Anno",
        "week": "Settimana",
        "day": "Giorno"
      },
      "addNewPrice": "Aggiungi nuovo prezzo",
      "editPrice": "Modifica Prezzo",
      "addPrice": "Aggiungi Prezzo",
      "subscriptionType": {
        "recurring": "Ricorrente",
        "oneTime": "Un dato"
      },
      "billingPeriod": {
        "monthly": "Mensile",
        "annually": "Annualmente",
        "weekly": "Settimanale",
        "daily": "Quotidiana"
      },
      "ariaLabels": {
        "freeMembership": "Radio button Iscrizione gratis",
        "paidMembership": "Radio button Iscrizione a pagamento"
      }
    },
    "menuOptions": {
      "details": "Dettagli",
      "subscriptions": "Abbonamento",
      "branding": "Branding",
      "themes": "Tema",
      "tabsConfiguration": "Mostra/Nascondi schede",
      "membershipQuestions": "Domande Iscrizione",
      "gamificationAndRewards": "Gamification e premi",
      "links": "Collegamenti",
      "newsletter": "Newsletter",
      "reportedContent": "Contenuti segnalato",
      "discovery": "Scoperta",
      "import": "Importa"
    },
    "newsletter": {
      "title": "Newsletter",
      "subheading": "Il Suo Riassunto della Comunità",
      "frequency": "Frequenza Newsletter",
      "description": "Un Riepilogo dei post popolari, dell'Attività dei Membri e delle occorrenze di questo Gruppo",
      "selectFrequency": "Seleziona la frequenza",
      "frequencies": {
        "off": "Disattivato",
        "daily": "Ogni giorno",
        "weekly": "Ogni settimana",
        "biweekly": "Ogni due settimane",
        "monthly": "Ogni mese"
      }
    },
    "tabConfiguration": {
      "title": "Mostra/Nascondi schede",
      "description": "Controlla quali schede appaiono nella tua comunità. Abilita o disabilita ogni scheda per creare un'esperienza mirata e semplificata per i tuoi membri.",
      "discussionDescription": "Avvia o partecipa a conversazioni per condividere aggiornamenti, idee e approfondimenti con la tua comunità.",
      "learningDescription": "Crea e gestisci corsi che aiutano i membri ad acquisire nuove competenze o conoscenze.",
      "eventsDescription": "Pianifica, organizza e visualizza le prossime sessioni, workshop o eventi comunitari.",
      "leaderboardDescription": "Riconosci i membri con le migliori prestazioni e incoraggia un coinvolgimento sano attraverso le classifiche.",
      "membersDescription": "Gestisci tutti i membri e i ruoli. Questa scheda rimane visibile agli amministratori anche quando è disabilitata, in modo che la gestione dei membri sia sempre accessibile.",
      "aboutDescription": "Presenta lo scopo, i valori e lo sfondo della tua comunità per aiutare i membri a entrare in contatto.",
      "discussionTooltip": "Discussione è una scheda centrale della comunità e non può essere disabilitata",
      "aboutTooltip": "La scheda Informazioni è necessaria per fornire informazioni essenziali sulla comunità e non può essere disabilitata."
    },
    "groupSettings": {
      "groupSettings": "Impostazioni Gruppo",
      "changeGroupType": "Modifica Digita Gruppo",
      "changeGroupTypeDescriptionPrivateToPublic": "Dinamico per un Gruppo Pubblico significa che ogni In sospeso Richieste sarà accettato automaticamente e Contenuto diventerà pubblicamente visibile. Procedi?",
      "changeGroupTypeDescriptionPublicToPrivate": "Dinamico per un Gruppo Privato significa che Nuovo Membri ha bisogno dell'approvazione e Contenuti rimane Nascosto fino a quando non viene Accettato. Procedi?",
      "changeGroupTypeConfirmation": "Sei sicuro che tu vuoi modificare Gruppo Digita?",
      "changeGroupTheme": "Modifica Tema Gruppo",
      "changeGroupThemeDescription": "Questo modificherà il tema per ogni Gruppo Membri. Sei sicuro che tu vuoi modificare Gruppo Tema?",
      "updatedGroupDetails": "Dettagli Gruppo Aggiornato",
      "unableToSaveDetails": "Ops! Impossibile archiviare Dettagli.",
      "groupNameIsRequired": "Il Nome del gruppo è Obbligatorio",
      "groupDescriptionIsRequired": "Gruppo Descrizione è Obbligatorio",
      "groupSlugIsRequired": "Il Gruppo Slug è Obbligatorio",
      "groupSlugMustContainOnly": "Il Gruppo Slug deve contenere solo lettere Minuscolo, Quantità e trattini",
      "groupSlugAlreadyExists": "Slug Gruppo esiste già. Utilizza uno Slug diverso poiché questo è già stato preso",
      "groupSlugRestricted": "Questo slug corrisponde a una delle nostre parole chiave riservate per i link della comunità. Utilizza uno slug diverso",
      "pleaseTryAgainLater": "Riprova più tardi",
      "unsavedChangesMessage": "Tu hai salvato il Gruppo Slug Dinamico, sei sicuro che tu voglia annullarlo?"
    },
    "import": {
      "header": "Importa i Membri Gruppo Skool e i loro Contenuti",
      "credentialDescription": "Inserisci il tuo Certificato Skool per Importa il tuo Gruppo Membri ei loro Contenuti",
      "csvUploadDescription": "Seleziona .csv File in Importa contatti Da Skool",
      "loginFailed": "Tu ho inserito una Email Non valido O password. Riprova.",
      "proceedWithImport": "Procedi con Importa?",
      "iAgree": "Sono d'accordo",
      "importTerms": "Cliccando su \"Accetto\", Tu conferma e riconosci che ci hai incaricato come Accordo indipendente di eseguire Servizi Attivo per tuo conto (\"Servizi\"). I Servizi Includi i Trasferisci di determinati dati, Dettagli, Contenuti, Proprietà intellettuale o qualsiasi Altro Contenuti (\"Informazioni\") da un Account della piattaforma Emesso a un Account della piattaforma Ricevuto . Tu dichiari e garantisci che (i) tu sei il legittimo titolare delle Informazioni in Account piattaforma Emesso , (ii) tu hai le autorizzazioni per concederci l'accesso Account della piattaforma Emesso per l'Intento di eseguire i Servizi, e (iii) i Trasferisci delle Informazioni non violeranno le Proprietà intellettuali di terze parti. O violeranno i contratti di terze parti. Accetti di indennizzare, difendere e manlevare noi da eventuali reclami di terze parti che sorgono come Risultato da una tua violazione dei rappresentanti e delle garanzie di cui sopra.",
      "pleaseDownloadCSV": "Scarica il File .CSV",
      "step01": "Passaggio 01-",
      "step02": "Passaggio 02-",
      "uploadCSV": "Carica il tuo .CSV",
      "step01Description": "Riempi in O aggiorna tutti i dettagli mancanti per il Gruppo Membri come Gmail, nome, ecc. Assicurati che il CSV sia caricato in",
      "thisTemplate": "questo modello",
      "importCSV": "Importa .CSV",
      "reSyncData": "Re-sincronizzazione dei tuoi dati Prima Scarica.",
      "refreshUserList": "Aggiorna Elenco Utente",
      "reSyncDataDescription": "Se Nuovo Utente sono stati aggiunti in frattempo, suggeriamo Tu di aggiornare il tuo Elenco e Scarica il CSV.",
      "pleaseDontChangeProfileSlug": "Si prega di non modificare il profilo Slug.",
      "selectFile": "Seleziona File",
      "changeFile": "Modifica File",
      "importMembersFailedText": "Ciò potrebbe essere dovuto al fatto che mancano Email Indirizzo. Per favore segno di spunta il tuo Importa File e Ripova con un indirizzo Email valido per questi Membri.",
      "upload": "Carica",
      "tryAgain": "Riprova",
      "syncAllPosts": "Sincronizzazione di ogni tua condivisione e commento",
      "membersCouldNotBeAdded": "Non è stato possibile aggiungere Membri al Gruppo.",
      "importMembersSuccess": "Abbiamo inviato Email a ogni individuo del Gruppo Membri, confermando la sua iscrizione in Gruppo e fornendo loro Accesso Dettagli. Questo aiuta a garantire che ogni Membri sia informato e possa accedere al Gruppo in modo efficace.",
      "importMembersAdded": "I Membri sono stati aggiunti con successo al Gruppo",
      "postsNotSynced": "I Post rimanenti non potrebbero essere la Sincronizzazione al Gruppo. Ciò potrebbe essere dovuto al fatto che gli Autori di Condividi non sono stati importati correttamente.",
      "migrationFailed": "Migrazione non riuscita. Riprova.",
      "migrationCompleted": "Migrazione Fatto!",
      "migrationInProgress": "Migrazione in corso",
      "createProfile": "Crea profilo",
      "enterCredentials": "Inserisci le credenziali",
      "uploadingInProgress": "Carica in corso!",
      "listMembers": "Elenco di Membri è in corso",
      "downloaded": "Scarica",
      "uploaded": "caricato",
      "listPostsDownloaded": "L'elenco di post è Scarica.",
      "listPostsDownloading": "L'elenco di post è in fase di download.",
      "posts": "post",
      "members": "Membri",
      "imported": "importato",
      "step1": "Passaggio 1",
      "step2": "Passaggio 2",
      "step1Description": "Crea a Membri Profilo in Skool Gruppo.",
      "step1Description2": "(inclusi Nome, Email Id e password)",
      "step2Description": "Inserisci Skool Membri Certificato",
      "skoolUrlPlaceholder": "Inserisci l'URL del tuo gruppo Skool",
      "emailPlaceholder": "Inserisci del tuo Skool Email Id",
      "emailTooltip": "Inserisci l' Email Membri con il tuo Account Skool",
      "passwordPlaceholder": "Inserisci la password del tuo Skool",
      "confirm": "Conferma",
      "validation": {
        "skoolUrl": "Si prega di inserire un URL Skool valido",
        "email": "Email è obbligatoria",
        "password": "La password è Obbligatoria"
      }
    },
    "approved": "Approvato",
    "pending": "In sospeso",
    "rejected": "Rifiutato"
  },
  "invitations": {
    "intent": "Aiuta questa comunità a crescere!",
    "cancelInvitation": "Annulla invito",
    "inviteMembers": "Invita i membri a collaborare a questa comunità.",
    "inviteLink": "Link di invito",
    "invitationLink": "link di invito",
    "buildYourCommunity": "Costruisci la tua comunità!",
    "inviteMembersToCollaborate": "Hai creato una nuova comunità! Invita i membri a collaborare a questa comunità.",
    "invite": "Invita",
    "basicInformation": "Informazioni di base",
    "permissions": "Autorizzazioni"
  },
  "createPost": {
    "title": "Crea nuovo post del blog",
    "placeholder": "A cosa stai pensando",
    "liveStream": "Streaming live",
    "slug": "Slug URL del post del blog",
    "titleHelp": "Il titolo, la descrizione e l'immagine verranno utilizzati per il tag meta SEO",
    "nameLabel": "Titolo del post del blog",
    "nameValidation": "Il titolo è obbligatorio",
    "descriptionLabel": "Descrizione del post",
    "descriptionHelp": "Fornisci una breve descrizione per consentire ai lettori di capire velocemente di cosa tratta il post. Funziona al meglio se è tra i 100 e i 250 caratteri",
    "descriptionValidation": "La descrizione è obbligatoria",
    "createLabel": "Crea post",
    "image": "Immagine del post del blog",
    "imageDescription": "La dimensione consigliata è 600px * 400px",
    "notificationTitle": "Post del blog creato",
    "notificationErrorTitle": "Impossibile creare il post del blog",
    "postingIn": "Pubblicazione in",
    "editingIn": "Modifica in"
  },
  "post": {
    "downloadRecording": "Scarica registrazione",
    "deletePost": "Elimina post",
    "reportPost": "Segnala Post",
    "editPost": "Modifica post",
    "createPost": "Crea post",
    "publish": "Pubblica",
    "publishPost": "Pubblica post",
    "addChannel": "Aggiungi canale",
    "selectChannel": "Seleziona canale",
    "addLink": "Aggiungi link",
    "removeLink": "Rimuovi link",
    "update": "Aggiorna",
    "unsavedChanges": "Alcune modifiche non sono state salvate",
    "unsavedChangesMessage": "Le modifiche non salvate andranno perse. Vuoi ancora procedere?",
    "unpinFromChannel": "Rimuovi dall'alto",
    "unpinFromHome": "Rimuovi dall'alto",
    "deletePostConfirmation": "Vuoi davvero eliminare questo post?",
    "reportPostConfirmation": "Vuoi davvero segnalare questo post?",
    "postNotFound": "Post non trovato",
    "postNotFoundMessage": "Il post che stai tentando di visualizzare è stato eliminato o non esiste.",
    "loadMoreComments": "Carica più commenti",
    "channelNotFound": "Canale non trovato",
    "isCurrentlyLive": "è attualmente live",
    "isStartingNow": "sta iniziando ora",
    "isHappeningInMinutes": "sarà disponibile tra {minutes} minuti",
    "isHappeningInHours": "sta accadendo in {hours} ora | sta accadendo in {hours} ora",
    "publicChannel": "Canale pubblico",
    "privateChannel": "Canale privato",
    "featured": "In primo piano",
    "featuredAbout": "Informazioni su In primo piano",
    "noPostsFound": "Nessun post trovato",
    "pinInfo": "Puoi aggiungere gli elementi da visualizzare nella parte superiore del gruppo, inclusi post, regole e hashtag.",
    "pinInfoEveryone": "Tutti nel gruppo vedranno questi elementi.",
    "pinInfoRemainVisible": "Gli elementi aggiunti in alto rimangono visibili fino a quando non vengono rimossi dall'alto.",
    "pinInfoNewestItem": "Quando aggiungi degli elementi in alto, l'elemento più recente appare all'inizio dell'elenco.",
    "onlyVisibleToAdmins": "Visibile solo agli amministratori",
    "featuredAboutDescription": "Gli amministratori hanno aggiunto questi elementi in alto affinché il gruppo li veda.",
    "channelNotFoundMessage": "Non sei più un membro del canale a cui stai tentando di accedere o il canale è stato eliminato.",
    "notifications": {
      "unpinned": "Rimosso dall'alto!",
      "pinned": "Appuntato!",
      "reported": "Il post è stato segnalato!",
      "error": "Qualcosa è andato storto!",
      "isCommentDisabled": "Feedback disabilitato!",
      "isCommentEnabled": "Commenti abilitati."
    },
    "movePostToChannel": "Sposta nel Canale",
    "pin": "Pin",
    "pinToHome": "Aggiungi a Home",
    "pinToChannel": "Aggiungi al Canale",
    "whatIsYourTitle": "Qual è il tuo titolo?",
    "postMovedToChannel": "Condividi spostata nel canale {channelName}",
    "upcomingEvent": "Prossimo evento",
    "turnOffCommenting": "Disattiva i commenti",
    "enableComments": "Abilita Commenti",
    "disableComments": "Disabilita feedback",
    "moveToPrivateChannelConfirmation": {
      "title": "Sposta nel canale privato",
      "message": "Stai per spostare questo post su un canale privato. Solo i membri di quel canale privato potranno vederlo. Vuoi continuare?"
    },
    "onlyAdminsCanPost": "Solo gli amministratori della comunità possono Condividi in questo Canale."
  },
  "reaction": {
    "noLikes": "Nessun Mi piace",
    "andOthers": "e {count} altri"
  },
  "UIConfirmation": {
    "privateGroup": "Questo gruppo è privato",
    "privateGroupMessage": "Devi essere un membro di questo gruppo per accedere a informazioni specifiche del gruppo. Richiedi l'accesso facendo clic sul pulsante Unisciti al gruppo."
  },
  "notifications": {
    "noNotificationsYet": "Ancora nessuna notifica",
    "whenYouGetNotifications": "Quando ricevi le notifiche, verranno mostrate qui",
    "markAllAsRead": "Contrassegna tutte come lette",
    "notifications": "Notifiche",
    "all": "Tutto",
    "unread": "Non letto",
    "checkNotifications": "Accedi per controllare le notifiche",
    "noNotifications": "Nessuna notifica!",
    "redirectedFromOldSlug": {
      "title": "Sei stato/a reindirizzato/a al link della community aggiornato",
      "content": "Questo è stato fatto per migliorare le prestazioni SEO di questa comunità. Per favore, aggiorni i suoi segnalibri con questo nuovo URL."
    }
  },
  "joinGroupModal": {
    "wahoo": "Evvai! 🎉 Richiesta inviata",
    "reviewRequestSoon": "Gli amministratori del nostro gruppo esamineranno presto la tua richiesta. Sii paziente e ti invieremo una notifica una volta approvata la tua iscrizione.",
    "nonMemberMessage": "Devi far parte di questo gruppo per mettere Mi piace e commentare i post",
    "subscribeFor": "Iscriviti per",
    "joinGroup": "UNISCITI AL GRUPPO",
    "membershipPending": "Iscrizione IN SOSPESO",
    "viewMembershipAnswers": "Visualizza le risposte Iscrizione",
    "requested": "Richiesto",
    "dayFreeTrial": "Prova gratuita di un giorno",
    "notPartOfGroup": "Tu non fai ancora parte di questo gruppo, la tua Iscrizione Richieste è in Recensione. Una volta che un amministratore avrà accettatoto tuo Richieste, notificheremo a Tu",
    "pleaseAnswerMembershipQuestions": "Rispondi alle domande di Iscrizione per unisciti questo gruppo",
    "answerQuestions": "Rispondi alle domande di iscrizione"
  },
  "userProfilePopover": {
    "active": "Attivo",
    "longAgo": "molto tempo fa",
    "chatDisabled": "Questo utente ha disabilitato la chat",
    "pointsToLevelUp": "punti per salire di livello",
    "profile": "Profilo",
    "deletedUser": "Utente eliminato",
    "joined": "Unione effettuata",
    "contributions": "Contributi"
  },
  "courses": {
    "by": "Da",
    "free": "Gratis",
    "unknownInstructor": "Istruttore sconosciuto",
    "courseRestricted": "Questo Percorso è Privato",
    "courseDeleted": "Questo corso è stato eliminato",
    "noMatchingCourseFound": "Nessun corso corrispondente trovato",
    "addCourse": "Aggiungi corso",
    "updateCourse": "Aggiorna corso",
    "access": "Tutti i membri hanno accesso",
    "unableToAddCourse": "Ops! Impossibile aggiungere il corso.",
    "pleaseTryAgainLater": "Riprova più tardi",
    "paymentIntegrationMissing": "Ops! Manca l'integrazione dei pagamenti",
    "paymentIntegrationMissingMessage": "Integra i pagamenti in loco per abilitare i corsi a pagamento",
    "course": "Corso",
    "courseInThisGroup": "un corso esistente in questo gruppo",
    "courseLinkCopied": "Link al corso copiato!",
    "buyNow": "ACQUISTA ORA",
    "locked": "BLOCCATO",
    "buyCourse": "ACQUISTA CORSO",
    "open": "APRI",
    "moveCard": "Sposta scheda",
    "courseViewMessage": "Per visualizzare i corsi devi far parte di questo gruppo.",
    "deleteCourse": "Elimina corso",
    "deleteCourseConfirmation": "Vuoi davvero eliminare questo corso?",
    "courseAccessNotGranted": "Accesso al corso non concesso",
    "courseAccessNotGrantedMessage": "Al momento stiamo lavorando per garantirti l'accesso al corso. Aggiorna la pagina e riprova tra un attimo.",
    "autoRenewsAfter": "Si rinnova automaticamente dopo",
    "oneTimePayment": "Pagamento una tantum",
    "emptyCoursesMessage": "Sembra una città fantasma. Non c'è niente da vedere qui",
    "updatedSuccessfully": "Aggiornamento del corso con successo",
    "addedSuccessfully": "Corso aggiunto con successo",
    "createCourse": "Crea nuovo corso",
    "emptyCourseLibrary": "La Sua libreria di percorsi è vuota!",
    "createdOutsideGokollabMessage": "Questa comunità è stata creata al di fuori di Gokollab & resa individuabile. Per Genera Nuovo Corsi, acceda alla comunità Da la sua Fonte Canale.",
    "createCourseOnGokollabMessage": "Genera un Nuovo Percorso Attivo Gokollab per renderlo disponibile ai Membri della tua comunità.",
    "or": "o",
    "createNewOne": "creane uno nuovo",
    "labels": {
      "selectCourse": "Seleziona corso",
      "courseVisibility": "Visibilità del corso",
      "courseAccess": "Accedi al corso",
      "coursePrice": "Prezzo del corso",
      "subscriptionType": "Tipo di abbonamento",
      "billingPeriod": "Periodo di fatturazione",
      "testMode": "Modalità test",
      "turnOnTestPayments": "Attiva i pagamenti di test utilizzando una carta di test",
      "currency": "Valuta",
      "trialDays": "Giorni di prova",
      "recurring": "Ricorrente",
      "free": "Gratis",
      "oneTime": "Un dato",
      "refresh": "Aggiorna",
      "accessStartsAtDay": "Accesso inizia alle Giorno",
      "maximumYouCanEnterIs365": "Massimo Tu che puoi inserire è 365",
      "allMembers": "ogni Membri",
      "levelUnlock": "Sblocco uniforme",
      "buyNow": "Acquista ora",
      "timeUnlock": "Sblocco dei dati",
      "gamificationLevel": "Uniforme di Gamification",
      "privateChannel": "Canale Privato",
      "private": "Privato",
      "marketingChannel": "Canale Marketing",
      "selectCurrency": "Seleziona valuta"
    },
    "placeholders": {
      "enterPrice": "Inserisci prezzo",
      "enterTrialDays": "Inserisci giorni di prova",
      "selectCurrency": "Seleziona uno",
      "selectBillingPeriod": "Seleziona uno",
      "billingPeriod": "Seleziona il periodo di fatturazione"
    },
    "validations": {
      "validPrice": "Inserisci un prezzo valido",
      "required": "Seleziona un corso",
      "validMembershipPrice": "Inserisci un prezzo di iscrizione valido",
      "validTrialDays": "Inserisci i giorni di prova validi",
      "requiredSubscriptionType": "Seleziona il tipo di abbonamento",
      "courseVisibility": "Seleziona Visibilità del corso",
      "requiredGamificationLevel": "Per favore, seleziona Gamification Uniforme",
      "requiredPrivateChannel": "Seleziona canale privato",
      "validAccessStartDay": "Inserisci un Accesso start Giorno valido"
    },
    "descriptions": {
      "buyNowDescription": "Questo corso è Pubblico al momento dell'acquisto",
      "timeUnlockDescription": "Membri Sblocca dopo X giorni",
      "levelUnlockDescription": "I Membri solo a una determinata Uniforme potranno essere sbloccati",
      "allMembersDescription": "ogni Membri ha Accesso a questo corso",
      "privateChannelDescription": "Membri di un canale Privato",
      "privateDescription": "Accesso consentito solo dall'amministratore"
    },
    "helperText": {
      "levelBased": "Basato sul livello",
      "timeLimited": "ora-Limited",
      "privateBased": "Privato",
      "free": "Gratis",
      "levelAvailableAt": "Disponibile presso Uniforme 0{value}",
      "timeLimitedAfterJoining": "Pubblico {value} {day} Dopo essere entrato a far parte del Gruppo",
      "day": "Giorno",
      "days": "giorni",
      "purchaseToUnlockAccess": "Acquista questo corso per sbloccare Accesso",
      "privateCourse": "Corso privato - Accesso consentito solo dall'amministratore",
      "locked": "Questo corso è bloccato",
      "unlockAtLevel": "Questo corso si sbloccherà presso Uniforme {level}",
      "unlockAfterDays": "Questo corso sbloccherà Dopo {days} {dayText}",
      "privateChannelBased": "Basato su canale Privato",
      "externalAccess": "Altro Gruppo/Offerta"
    },
    "manageAccess": {
      "manageCourses": "Gestisci corsi",
      "revokeCourseAccess": "Gestisci corsi",
      "grantCoursesAccess": "Concedi corsi",
      "removeAccess": "Rimuovi accesso",
      "grantAccess": "Concedi accesso",
      "grant": "Concedi",
      "clear": "Rimuovi",
      "selectAll": "Seleziona tutto",
      "revokeAccessConfirmTitle": "Rimuovere l'accesso al corso?",
      "revokeAccessConfirmMessage": "Vuoi davvero rimuovere l'accesso a \"{courseName}\" per {userName}?",
      "externalAccessTooltip": "Non è possibile rimuovere: l'utente ha accesso da un altro gruppo o offerta",
      "cannotRevokeAutoAccess": "Impossibile rimuovere: l'accesso è concesso automaticamente in base alle impostazioni del corso (a pagamento, livello, tempo o gratis)",
      "searchPlaceholder": "Cerca corsi",
      "noCoursesFound": "Nessun corso trovato",
      "noCoursesSelected": "Nessun corso selezionato ancora",
      "noCoursesAvailable": "Nessun corso disponibile da concedere",
      "noSearchResults": "Nessun risultato di ricerca",
      "failedToLoadCourses": "Impossibile caricare i corsi",
      "accessRevoked": "Accesso al corso rimosso con successo",
      "failedToRevokeAccess": "Impossibile rimuovere l'accesso al corso",
      "accessGranted": "Accesso al corso concesso correttamente",
      "multipleAccessGranted": "{count} corsi concessi correttamente",
      "failedToGrantAccess": "Impossibile concedere l'accesso al corso"
    },
    "ariaLabels": {
      "courseCard": "Scheda del corso",
      "courseCardActions": "Azioni scheda corso",
      "editCourse": "Modifica corso",
      "deleteCourse": "Elimina corso",
      "moveCard": "Sposta scheda",
      "copyLink": "Copia link",
      "cardImage": "Immagine della scheda del corso"
    }
  },
  "about": {
    "notifications": {
      "errorUploadingFile": "Errore durante il caricamento del file"
    },
    "uploadLinkVideo": "Carica/collega video",
    "removeMedia": "Rimuovi {fileName} contenuti multimediali"
  },
  "leaderboard": {
    "level": "Livello",
    "lastUpdated": "Ultimo aggiornamento",
    "members": "Membri",
    "percentOfMembers": "{percentage}% dei membri",
    "rewards": "Ricompense",
    "allTime": "Generale",
    "pointsToLevelUp": "punti per salire di livello",
    "points": "Punti",
    "leaderboard7d": "Classifica (7 giorni)",
    "leaderboard30d": "Classifica (30 giorni)",
    "leaderboardAlltime": "Classifica (Generale)",
    "yourRank": "La tua posizione",
    "noActivityToShow": "Nessuna attività da mostrare",
    "rewardsWillBeDisplayedHere": "Le ricompense verranno visualizzate qui",
    "seeAllLeaderboards": "Vedi tutte le classifiche",
    "addRewards": "Aggiungi ricompense",
    "howPointsWork": "Guadagni punti quando gli altri membri mettono Mi piace ai tuoi post o commenti. 1 Mi piace = 1 punto. Questo incoraggia gli utenti a produrre contenuti di qualità e a interagire con gli altri membri della loro comunità.",
    "levels": "Livelli",
    "levelsDescription": "Man mano che guadagni punti, sali di livello. Il tuo livello viene mostrato in basso a destra del tuo avatar. Il numero di punti necessari per passare al livello successivo viene mostrato tramite la barra di avanzamento nella schermata della classifica.",
    "pointsAndLevels": "Punti & Livelli"
  },
  "events": {
    "createEvent": "Crea evento",
    "dragAndDrop": "Trascina e rilascia un file SVG, PNG o JPG (max. 800x400px)",
    "editEvent": "Modifica evento",
    "addEvent": "Aggiungi evento",
    "paymentDetails": "Dettagli di pagamento",
    "event": "Evento",
    "goBack": "Torna indietro",
    "cancelEdit": "Annulla Modifica",
    "cancelEvent": "Annulla evento",
    "next": "Successivo",
    "saveEvent": "Salva evento",
    "editRecurringEvent": "Modifica evento ricorrente",
    "thisEvent": "Questo evento",
    "thisAndFollowingEvents": "Questo e gli eventi successivi",
    "ok": "OK",
    "deleteRecurringEvent": "Elimina evento ricorrente",
    "allEvents": "Tutti gli eventi",
    "adminsFreeForPaidEvents": " * Gli amministratori possono registra a Pagato Eventi gratuitamente",
    "deleteEvent": "Elimina evento",
    "onceEventDeleted": "Una volta eliminato, l'evento non verrà mostrato nel calendario.",
    "toRegister": "per registrarti",
    "calendar": "Calendario",
    "addToCalendar": "Aggiungi al calendario",
    "declineRegistration": "Rifiuta",
    "paymentFailedMessage": "Il tuo pagamento non è andato a buon fine a causa di circostanze impreviste! Riprova più tardi.",
    "upcoming": "Prossimo",
    "noMoreEvents": "Non ci sono più eventi da mostrare",
    "joinGroupToRegister": "Devi far parte di questo gruppo per registrarti a questo evento",
    "past": "Passato",
    "youHaveRegisteredForOneEvent": "Hai effettuato la registrazione per 1 evento. Ti invieremo un promemoria un giorno prima di ogni evento.",
    "upcomingEvents": "Prossimi eventi",
    "noUpcomingEvents": "Nessun evento in programma",
    "pastEvents": "Eventi passati",
    "noPastEvents": "Nessun evento passato",
    "noMatchingEventFound": "Nessun evento corrispondente trovato",
    "week": "Settimana",
    "month": "Mese",
    "today": "Oggi",
    "registrationConfirmed": "Registrazione confermata per {event}.",
    "eventDeletedOrRestricted": "Evento Eliminato o Privato",
    "eventDeleted": "Evento eliminato",
    "eventRestricted": "Non hai accesso a questo evento",
    "validations": {
      "titleValidation": "Il titolo è obbligatorio",
      "colorValidation": "Il colore è obbligatorio",
      "startTimeValidation": "L'ora di inizio è obbligatoria",
      "endTimeValidation": "L'ora di fine è obbligatoria",
      "endTimeAfterStartTime": "L'ora di fine deve essere successiva all'ora di inizio",
      "startTimeMustBeInFuture": "L'ora di inizio deve essere nel futuro",
      "locationValidation": "Il luogo è obbligatorio",
      "locationValidationMobile": "Il luogo è obbligatorio",
      "locationUrlValidation": "È necessario un URL di posizione valido",
      "descriptionValidation": "La descrizione è obbligatoria",
      "descriptionValidationMaxLength": "La descrizione non può superare i 300 caratteri",
      "recaptchaError": "Verifica non riuscita! Riprova",
      "repeatIntervalValidation": "L'occorrenza è obbligatoria",
      "repeatIntervalValidator": "L'intervallo di ripetizione dovrebbe essere un giorno, una settimana, un mese o un anno",
      "repeatIntervalRequired": "L'intervallo di ripetizione è obbligatorio",
      "repeatOccurrenceValidator": "L'occorrenza di ripetizione deve essere maggiore di 0",
      "repeatOccurrenceRequired": "L'occorrenza di ripetizione è obbligatoria",
      "invalidDateFormat": "Formato di data non valido",
      "endDateMustBeAfterStartDate": "La data di fine deve essere successiva alla data di inizio dell'evento",
      "recurringEndDateValidation": "È obbligatoria una data di fine ricorrente",
      "repeatsOnValidation": "Seleziona almeno un giorno",
      "invalidDaySelection": "Selezione del giorno non valida",
      "endOptionRequired": "L'opzione di fine è obbligatoria",
      "levelValidation": "Seleziona un livello",
      "courseValidation": "Seleziona un corso",
      "channelValidation": "Seleziona un canale",
      "eventPriceValidation": "Il prezzo è obbligatorio e deve essere maggiore di {min}"
    },
    "placeholders": {
      "selectStartTime": "Seleziona ora di inizio",
      "selectEndTime": "Seleziona ora di fine",
      "selectLocation": "Seleziona luogo",
      "locationUrl": "Link/Indirizzo",
      "description": "Descrizione",
      "selectRecurringEndDate": "Seleziona data di fine ricorrente",
      "selectDate": "Seleziona data",
      "event": "Evento",
      "selectColor": "Seleziona un colore",
      "selectAttendees": "Seleziona partecipanti",
      "selectPrivateChannel": "Seleziona canale privato",
      "selectCourse": "Seleziona corso",
      "selectLevels": "Seleziona livelli",
      "selectCalendar": "Seleziona calendario"
    },
    "labels": {
      "startTime": "Ora di inizio",
      "endTime": "Ora di fine",
      "others": "Altri",
      "oneTimePriceForEventRegistration": "prezzo una tantum per la registrazione all'evento.",
      "totalAmount": "Importo totale",
      "cardAuthorizationText": "Fornendo i dati della tua carta, consenti a {locationName} di addebitare sulla carta i pagamenti futuri in conformità con i loro termini.",
      "secureAndSafePayments": "Pagamenti sicuri al 100%",
      "day": "Giorno",
      "week": "Settimana",
      "month": "Mese",
      "year": "Anno",
      "recurringEvent": "L'evento sarà ricorrente?",
      "repeatsEvery": "Si ripete ogni",
      "repeatsOn": "Si ripete il",
      "end": "Fine",
      "ends": "Bene",
      "neverEnds": "Non finisce mai",
      "orange": "Arancione",
      "red": "Rosso",
      "blue": "Blu",
      "green": "Verde",
      "violet": "Violetto",
      "purple": "Viola",
      "yellow": "Giallo",
      "title": "Titolo",
      "color": "Colore",
      "allMembers": "Tutti i membri",
      "membersAtALevel": "Membri a un livello",
      "membersOfACourse": "Membri di un corso",
      "membersOfAPrivateChannel": "Membri di un canale privato",
      "whoCanAttendTheEvent": "Chi può partecipare all'evento?",
      "channel": "Canale",
      "course": "Corso",
      "level": "Livello",
      "remindAttendeesByEmail": "Ricorda ai partecipanti tramite Email 1 Giorno Prima",
      "hideLocationFromNonAttendees": "Nascondi il luogo a chi non partecipa.",
      "addChargesToTheEvent": "Aggiungi fatturazione all'Evento",
      "noPaymentRequired": "Nessun pagamento Obbligatorio",
      "location": "Luogo",
      "link": "Link",
      "description": "Descrizione",
      "timezone": "Fuso orario",
      "eventType": "Tipo di evento",
      "eventTypeChangeWarning": "Dinamico al Tipo di evento O pricing si applicherà ad ogni occorrenze in serie.",
      "never": "Mai",
      "on": "Attivo",
      "after": "Dopo",
      "occurrences": "occorrenze",
      "selectEventEnd": "Seleziona Quando l'evento andrà bene.",
      "turnOnTestPayments": "Gira Attivo Test pagamenti tramite una Test card",
      "pay": "Paga",
      "hideAttendees": "Nascondi partecipa a Da Gruppo Membri",
      "guests": "{count} ospiti",
      "guestList": "Elenco Ospite",
      "noAttendees": "Ancora nessun partecipante",
      "viewAttendees": "Visualizza partecipanti",
      "exportAttendees": "Esporta partecipanti"
    },
    "notifications": {
      "eventCreated": "Evento per creare con successo!",
      "eventUpdated": "Evento aggiornato con successo!",
      "eventCreationFailed": "Creazione Evento non riuscita!",
      "eventUpdateFailed": "Aggiornamento Evento non riuscito!",
      "eventDeleted": "Evento eliminato con successo!",
      "eventDeletionFailed": "Eliminazione dell'evento non riuscita!",
      "paymentFailed": "Pagamento non riuscito!",
      "registrationSuccessful": "Registrazione riuscita!",
      "registrationFailed": "Registrazione non riuscita!",
      "addToCalendarFailed": "Impossibile aggiungere l'evento al calendario!",
      "locationDetailsCopied": "Dettagli sul luogo copiati negli appunti!",
      "registrationDeclined": "Registrazione rifiutata!",
      "registrationDeclinedFailed": "Rifiuto della registrazione non riuscito!",
      "fetchAttendeesFailed": "Non riuscito caricare i partecipanti",
      "emailCopied": "Email a Copiato negli appunti",
      "exportAttendeesFailed": "Impossibile esportare i partecipanti"
    },
    "selectCalendar": "Seleziona calendario",
    "eventImage": "Immagine evento",
    "errorLoadingEvent": "Errore durante il caricamento dell'evento"
  },
  "login": {
    "invite": "ti ha invitato a unirti"
  },
  "contentReports": {
    "contentDeleted": "Contenuto eliminato!",
    "noActionTaken": "Nessuna azione intrapresa in merito al contenuto segnalato!",
    "reportedContentNotFound": "Contenuto segnalato non trovato, potrebbe essere già stato preso in considerazione.",
    "reported": "Segnalato",
    "viewAllReportedContentHere": "Puoi visualizzare tutti i contenuti segnalati qui",
    "takeActionOnReportedContent": "Intraprendi un'azione sul contenuto segnalato",
    "andOthers": "e altri {count}",
    "reportedThisPost": "ha segnalato questo post",
    "keep": "MANTIENI",
    "remove": "RIMUOVI",
    "deleteContent": "Elimina contenuto",
    "deleteConfirmation": "Vuoi davvero eliminare questo contenuto?",
    "noMemberReportedContent": "Nessun contenuto segnalato dai membri",
    "whenMembersReportPostsOrComments": "Quando i membri segnalano post o commenti, questi verranno visualizzati qui per essere rivisti da te. Puoi mantenerli o eliminarli, nonché sospendere, rimuovere o bloccare i membri che li hanno pubblicati.",
    "reportedThisComment": "Hai segnalato questo commento"
  },
  "contentUnavailable": {
    "thisContentIsntAvailable": "Questo contenuto non è disponibile al momento",
    "whenThisHappens": "Quando questo accade, di solito è perché il titolare l'ha condiviso solo con un piccolo gruppo di persone o ha modificato chi può vederlo o è stato eliminato"
  },
  "search": {
    "noResultsFor": "0 risultati per \"{query}\" nella comunità",
    "noResultsFound": "Nessun risultato trovato"
  },
  "noCommunities": {
    "noCommunitiesFound": "Nessuna comunità trovata",
    "startCreatingYourOwnCommunities": "Inizia a creare le tue comunità e interagisci con il tuo pubblico!",
    "noCommunitiesFoundGokollab": {
      "notJoinedA": "Non si è unito a",
      "communities": "Comunità",
      "yet": "Ancora"
    },
    "noCommunitiesFoundGokollabDescription": "Scopri gli spazi in cui le persone condividono idee, si sostengono a vicenda e crescono insieme."
  },
  "noCourses": {
    "noCoursesFoundGokollab": {
      "notEnrolledInA": "Non iscritto a un",
      "course": "Corso",
      "yet": "Ancora"
    },
    "noCoursesFoundGokollabDescription": "Esplora i corsi ad alto impatto progettati per aiutarti a imparare, migliorare e ottebere successo."
  },
  "notFound": {
    "ohNo": "oh no...",
    "weHaveHadAnError": "Si è verificato un errore",
    "error404": "Errore 404",
    "sorryPleaseCheckBack": "Spiacenti... Ricontrolla tra un momento."
  },
  "time": {
    "justNow": "Proprio ora",
    "timeAgo": "fa {value} {unit}",
    "timeAgoFull": "fa {value} {unit}",
    "units": {
      "year": "a",
      "years": "anni",
      "month": "m",
      "months": "mesi",
      "week": "sett",
      "weeks": "settimane",
      "day": "g",
      "days": "giorni",
      "hour": "h",
      "hours": "ore",
      "minute": "m",
      "minutes": "minuti",
      "second": "s",
      "seconds": "Secondi",
      "monthly": "Mensile",
      "weekly": "Settimanale",
      "annually": "Annualmente"
    },
    "dayAbbreviations": {
      "mon": "Lun",
      "tue": "Mar",
      "wed": "Mer",
      "thu": "Gio",
      "fri": "Ven",
      "sat": "Sab",
      "sun": "Dom"
    }
  },
  "emojiPicker": {
    "notfound": "Nessuna Emoji trovato",
    "recent": "Usato di frequente",
    "smileys": "Faccine ed emoticon",
    "people": "Persone e Corpo",
    "nature": "Animali e natura",
    "foods": "Cibo e bevande",
    "activity": "Attività",
    "places": "Viaggi e posti",
    "objects": "Oggetti",
    "symbols": "Simboli",
    "flags": "Flag",
    "custom": "Personalizzato"
  },
  "topNavBarHeaderText": {
    "discussion": "Discussione",
    "learning": "apprendimento",
    "people": "Persone"
  },
  "globalUserProfile": {
    "ownedBy": "Di proprietà di {name}",
    "memberships": "Iscrizioni",
    "membershipsInCommon": "Iscrizioni ({count} in comune)",
    "membersCount": "{count} membri",
    "contributions": "{count} contributi a {group}",
    "contributionsFor": "Contributi per",
    "justPosts": "Solo post",
    "postAndComments": "Post e commenti",
    "followSuccess": "Tu hai iniziato a seguire",
    "unfollowSuccess": "Non stai più seguendo"
  },
  "profile": {
    "active": "Attivo",
    "ago": "fa",
    "bio": "Biografia"
  },
  "golive": {
    "golive": "Vai in diretta",
    "selectVideoSourceToStart": "Seleziona una fonte dei video per avviare lo streaming",
    "chooseHowToGoLive": "Scegli come vuoi andare in diretta",
    "flipCamera": "Gira la fotocamera",
    "participants": "Partecipanti",
    "chats": "Chat",
    "react": "React",
    "raise": "Alza",
    "shareScreen": "Condividi",
    "letsCheckYourCamAndMic": "Controlliamo la tua cam e il tuo microfono",
    "hostedBy": "Ospitato da",
    "join": "Unisciti",
    "needCameraPermission": "Hai bisogno dell'autorizzazione della fotocamera",
    "needMicrophonePermission": "È necessaria l'autorizzazione del microfono",
    "needSpeakerPermission": "È necessaria l'autorizzazione dell'oratore",
    "createLiveVideo": "Crea un video live",
    "host": "Host",
    "chooseWhereToPost": "Scegli dove pubblicare",
    "whenAreYouGoingLive": "Quando andrai live?",
    "postingIn": "pubblicazione in",
    "live": "Live",
    "postDetails": "Dettagli del post",
    "streamingSoftware": "Software di streaming",
    "streamingSoftwareDescription": "Puoi utilizzare un software di streaming come Zoom, OBS o StreamYard per trasmettere direttamente. È sufficiente copiare l'URL e la chiave di streaming forniti nelle impostazioni del software di streaming. Una volta configurata, avvia la trasmissione nel software e verrà trasmessa automaticamente in diretta sulla piattaforma selezionata.",
    "streamKey": "Chiave di streaming",
    "streamKeyDescription": "Puoi riutilizzarla ogni volta che fai una diretta. È possibile trasmettere un solo video live alla volta con la chiave di streaming persistente.",
    "serverUrl": "URL del server",
    "serverUrlDescription": "Questo può essere indicato come \"URL\" o \"Indirizzo\" nel tuo software di streaming.",
    "selectVideoSource": "Seleziona fonte video",
    "copyPasteStreamKey": "Copia e incolla la chiave di streaming nel tuo software di streaming.",
    "copyPasteServerUrl": "Copia e incolla l'URL del server nel tuo software di streaming.",
    "addPostDetails": "Aggiungi dettagli del post",
    "enterTitle": "Inserisci titolo",
    "notifyMembers": "Avvisa i membri che stai andando in diretta (invia solo notifiche in-app e push)",
    "notifyMembersMobile": "Avvisa i membri che stai andando in diretta",
    "meetingRoom": "Sala riunioni",
    "meetingRoomDescription": "Utilizza la funzione Sale riunioni per ospitare sessioni dal vivo in cui tutti i partecipanti possono accendere le proprie webcam, riattivare l'audio e interagire in tempo reale. In questo modo si crea un'esperienza di stanza virtuale simile a Zoom o Google Meet, consentendo a tutti di vedersi e parlare faccia a faccia.",
    "cameraControls": "Controlli della fotocamera",
    "cameraControlsTooltip": "Configura le impostazioni della videocamera e dell'audio prima di andare in diretta. Assicurati che la videocamera e il microfono siano collegati correttamente e dispongano delle autorizzazioni necessarie.",
    "selectMediaSource": "Seleziona una fonte multimediale",
    "startScreenShare": "Avvia la condivisione dello schermo",
    "stopScreenShare": "Interrompi la condivisione dello schermo",
    "wasLive": "era in diretta",
    "isLive": "è in diretta",
    "goingLive": "sta andando in diretta",
    "tapToAddDescription": "Tocca per aggiungere una descrizione...",
    "selectChannel": "Seleziona canale",
    "saveAsPost": "Mantieni la diretta streaming come post",
    "selectVideoSourceTooltip": "Puoi scegliere tra software di streaming o webcam quando vai in diretta:\n\n1. Software di streaming\n   • Ti forniremo una chiave di streaming e un URL di streaming.\n   • È necessario configurarli in Zoom, OBS o qualsiasi software di terze parti che supporti le dirette streaming.\n\n2. Webcam\n   • Trasmetti in diretta direttamente utilizzando la videocamera e il microfono.\n   • I partecipanti possono visualizzare la diretta streaming e interagire attraverso la live chat.\n   • In qualità di host, puoi controllare e revocare l'accesso alla videocamera o al microfono in qualsiasi momento.",
    "pleaseSelectCameraMicrophoneSpeaker": "Seleziona la videocamera, il microfono e l'altoparlante",
    "pleaseStartStreamBeforeGoingLive": "Avvia lo streaming prima di andare in diretta",
    "watching": "In visione",
    "processingRecording": "Elaborazione della registrazione",
    "recordingFailed": "Registrazione non disponibile",
    "recordingFailedDescription": "Abbiamo riscontrato un problema durante l'elaborazione di questa sessione live e non è stato possibile salvare la registrazione",
    "streamEndedRecordingWillBeAvailableSoon": "Streaming terminato. La registrazione è in fase di elaborazione e sarà disponibile a breve.",
    "joinStream": "Unisciti allo streaming",
    "recordingInProgress": "Registrazione in corso",
    "recordingNotAvailable": "Registrazione non riuscita",
    "leaveSession": "Lascia sessione",
    "endSession": "Termina sessione",
    "rec": "REC",
    "selectCamera": "Seleziona videocamera",
    "noCamerasFound": "Nessuna fotocamera trovata",
    "cameraPermissionNeeded": "Autorizzazione fotocamera necessaria",
    "leave": "Lascia",
    "chooseMicCam": "Seleziona microfono/videocamera",
    "selectMicrophone": "Seleziona Microfono",
    "selectSpeaker": "Seleziona altoparlante",
    "noMicrophonesFound": "Nessun microfono trovato",
    "noSpeakersFound": "Nessun altoparlante trovato",
    "microphonePermissionNeeded": "Autorizzazione microfono necessaria",
    "speakerPermissionNeeded": "Autorizzazione altoparlante necessaria",
    "noParticipantOpenCamOrMic": "Questo incontro non è stato registrato perché nessun partecipante ha attivato il microfono o la videocamera. Le registrazioni vengono create solo quando almeno un partecipante interagisce."
  }
}
